<template>
  <div class="search-form d-flex pt-2">
    <input type="text" class="form-control flex-1" v-model="search" :placeholder="config.placeholder" @keyup.enter="submit" />
    <button class="btn btn-light ml-2" @click.stop.prevent="submit">Search</button>
    <div v-if="config.moreFilters" class="btn btn-light mb-0 ml-2" @click.stop.prevent="toggleMoreFilters">
      <i class="ti ti-adjustments"></i>
    </div>
    <div v-if="config.moreActions" class="btn btn-light mb-0 ml-2" @click.stop.prevent="toggleMoreActions">
      <i class="ti ti-grid-dots"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      search_by: ''
    }
  },
  created() {
    if (this.$route?.query?.search) {
      this.search = this.$route.query.search
    }
    if (this.$route?.query?.search_by) {
      this.search_by = this.$route.query.search_by
    }
  },
  methods: {
    submit() {
      this.$emit('change-filters', { search: this.search, search_by: this.search_by }, { refresh: true, goToFirst: true })
    },
    toggleMoreFilters() {
      this.$emit('toggleMoreFilters', null)
    },
    toggleMoreActions() {
      this.$emit('toggleMoreActions', null)
    }
  },
  props: {
    config: {
      type: Object,
      default() {
        return {
          placeholder: 'Search...'
        }
      }
    }
  },
  watch: {
    'config.query.search'(newVal) {
      if (this.search == newVal) return
      this.search = newVal
    }
  }
}
</script>

<style lang="scss">
.search-form {
  div.btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ced4da;
    border-radius: var(--border-radius, 0.25rem);
    margin: 0 0 10px;
    width: 41px;
    height: 41px;
    i {
      font-size: 1.65rem;
      color: #666;
    }
  }
}
</style>
